import React from "react";
import "../App.scss";
import colorTheme from "../Components/colorTheme";

/** Our privacy policy */
const Privacy = () => {
  const theme = colorTheme();
  return (
    <div className="privacy-container" style={{ color: theme.primary }}>
      <h3>Privacy Policy</h3>
      <p>Last updated 05/09/2022</p>
      <p>
        This Privacy Policy explains Tom Mboya University Student App (“TMUS” or
        “we” or “our”) privacy practices for visitors to our proprietary
        Internet site at www.tmuc.netlify.app (the “Website”). We created this
        Privacy Policy to explain what information we gather from you when you
        visit our Website and how we may use and disclose this information.
      </p>
      <p>
        This Privacy Policy is incorporated into and made a part of TMUS' Terms
        of Use.You, our clients are our main driver and we value you and the
        information you trust us as a user. We wish to acknowledge our true and
        honest commitment to your individual right to data and privacy
        protection. In an effort to outline how we handle information obtained,
        we share with you our Privacy Policies.
      </p>
      <p>
        Tom Mboya University Student App, is committed to keeping any and all
        personal information collected of those individuals that visit our
        website and make use of our online facilities and services accurate,
        confidential, secure and private. Our privacy policy has been designed
        and created to ensure those affiliated with of our commitment and
        realization of our obligation not only to meet but to exceed most
        existing privacy standards.
      </p>
      <p>
        By using our Website, you consent to the collection, use and disclosure
        of your personal information as described in this Privacy Policy. We
        reserve the right to change this Privacy Policy at any time. If we make
        any material changes to our Privacy Policy, we will post a new policy on
        the Website. Policy changes will apply only to information collected
        after the date of the change.
      </p>
      <p>
        This Privacy Policy applies only to information collected through our
        Website and not to information collected offline.
      </p>
      <p>
        Withdrawal of consent hereunder. You may at any time withdraw a consent
        granted hereunder by contacting us and stating so. In case of
        withdrawal, TMUS will not process Personal Data subject to this consent
        any longer unless legally required to do so.
      </p>

      <h4>HOW DO WE USE YOUR INFORMATION?</h4>
      <p>
        Tom Mboya University Student App, may collect and may make use of
        personal information to assist in the operation of our website and to
        ensure delivery of the services you need and request. The use of
        information collected is to personalize your experience, to improve the
        website, and customer service, to administer a contest, promotion,
        survey or other site feature, to follow up with you after correspondence
        (live chat, email or phone inquiries).
      </p>
      <p>
        At times, we may find it necessary to use personally identifiable
        information as a means to keep you informed of other possible products
        and/or services, through our emails,messages, that may be available to
        you. Tom Mboya University Student App may also be in contact with you
        with regards to completing surveys and/ or research questionnaires
        related to your opinion of current or potential future services may be
        offered.
      </p>
      <p>
        Tom Mboya University Student App can disclose your personal information,
        without prior notice to you, only if required to do so in accordance
        with applicable laws and/or in a good faith belief that such action is
        deemed necessary or is required in an effort to:
      </p>
      <ol>
        <li>
          Remain in conformance with any decrees, laws or statues or in an
          effort to comply with any process which may be served, upon and/ or
          our website;
        </li>
        <li>
          Maintain, safeguard and/or preserve all the rights and/or property of:
          and
        </li>
        <li>
          Perform under demanding conditions in an effort to safeguard the
          personal safety of users of and/or general public.
        </li>
      </ol>
      <p>
        It comes to the collection of personal information from children under
        the age of 16 years old, the Children’s Online Privacy Protection Act
        (COPPA) puts parents in control. The Federal Trade Commission, United
        States’ consumer protection agency, enforces the COPPA Rule, which
        spells out what operators of websites and online services must do to
        protect children’s privacy and safety online.
      </p>
      <p>
        We do not specifically market to children under the age of 16 years old.
      </p>
      <h4>OUR DIFFERENT DATA RELATIONSHIP</h4>
      <p>
        This Privacy Policy explains Tom Mboya University Student App (“TMUS” or
        “we” or “our”) privacy practices for visitors to our proprietary
        Internet site at www.tmuc,netlify.app (the “Website”). We created this
        Privacy Policy to explain the first interaction with TMUS, when you become
        our user by signing up for our services, we become a data
        <b>controller of your Personal Data</b>. Our general terms and our
        privacy policy states exactly what we do with your data for this
        interaction, we can guarantee that we will control your personal data in
        a GDPR (General Data Protection Regulation) compliant manner and that we
        have signed data processing agreements with so that your data is also
        <b>processed</b> in a GDPR compliant manner.
      </p>
      <h4>AFFILIATION</h4>
      <p>
        We are not affiliated to any other services that may not be stated
        however we recognise having a close relationship with www.tmuc.ac.ke
        which is a service owned by Tom Mboya University.
      </p>
      <h4>DO WE DISCLOSE THE INFORMATION WE COLLECT TO OUTSIDE PARTIES?</h4>
      <p>
        We do not sell to, trade with or otherwise transfer to outside parties
        your personally identifiable information unless we provide you with
        advance notice and consent, except as described herein. The term
        "outside parties" does not include website hosting partners and other
        parties who assist us in operating our Website, unless order so by
        school administration and those parties agree to keep this information
        confidential.
      </p>
      <p>
        In the event that we sell our App, or otherwise transfer any assets of
        our Application, we may provide your information to the purchaser so
        that you may continue the relationship or business with us and our
        products. We may also release your information when we believe that
        release is necessary to comply with law, enforce the policies of our
        Website or protect our or others' rights, property or safety.
      </p>
      <p>
        However, non-personally identifiable visitor information may be provided
        to other parties for marketing, advertising or other uses.
      </p>
      <p>Our site allows third-party behavioral tracking.</p>
      <h4>YOUR CONSENT</h4>
      <p>
        By using our services, registering an account, you consent to this
        privacy policy
      </p>
      <h4>CONTACT US</h4>
      <p>Email: kevinsshikuku@gmail</p>
      <p>phone: 0740253367</p>
    </div>
  );
};

export default Privacy;
